import createHistory from 'history/createBrowserHistory';
import queryString from 'query-string';

const history = createHistory();

export default history;

export function replace(params = {}) {
  const pathname = params.pathname || location.pathname;
  const query = params.query || queryString.parse(location.search);
  const qs = queryString.stringify(query);
  const search = (qs.length > 0) ? `?${qs}` : '';

  history.replace({
    pathname,
    search,
  });
}

export function update(params = {}) {
  const query = queryString.parse(location.search);
  const nextQuery = params.query;

  replace({
    pathname: params.pathname,
    query: Object.assign({}, query, nextQuery),
  });
}



// WEBPACK FOOTER //
// ./app/javascript/utils/history.js